<template>
  <div>
    <el-form ref="formRef" :model="goldDetailForm" label-width="140px">
      <el-form-item label="头像：">
        <el-image style="width: 80px; height: 80px" :src="goldDetailForm.headImg.smallHeadImg"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
      </el-form-item>
      <el-form-item label="信息：">
        <div class="item-info">
          <UserInfoList :row="goldDetailForm" showList="name,phone,uid,city,birth"/>
          <p>身高：{{ goldDetailForm.height }}</p>
        </div>
      </el-form-item>
      <el-form-item label="状态：">
        <div class="item-info">
          <p style="display: flex">身份证认证：<get-plain v-if="goldDetailForm.identityAuth.identityCode && goldDetailForm.identityAuth.identityCode !=0" title="" :code="goldDetailForm.identityAuth.identityCode" :uid="goldDetailForm.uid" :type="10" :subType="1"/></p>
          <p>信息审核：{{goldDetailForm.resumeState == 0 ? '未提交' : goldDetailForm.resumeState == 1 ? '待审核' : goldDetailForm.resumeState == 2 ? '已通过' : goldDetailForm.resumeState == 3 ? '不通过' : '--'}}</p>
          <p>微信审核：{{goldDetailForm.wechatState == 0 ? '未提交' : goldDetailForm.wechatState == 1 ? '待审核' : goldDetailForm.wechatState == 2 ? '已通过' : goldDetailForm.wechatState == 3 ? '不通过' : '--'}}</p>
          <p>是否vip：{{goldDetailForm.vipState == 0 ? '否' : goldDetailForm.vipState == 1 ? '是' : goldDetailForm.vipState == 2 ? '是' : '--'}}</p>
        </div>
      </el-form-item>
      <el-form-item label="金币余额：">
        {{ goldDetailForm.goldBalance }}
      </el-form-item>
      <el-form-item label="金币数量：">
        <el-input v-model="goldNum" placeholder="请输入金币数量" style="width: 90%"/>
        <p style="color: red; font-size: 12px;">* 允许输入负数，负数则代表扣罚对应的数量</p>
      </el-form-item>
      <el-form-item label="账单名称：">
        <el-input v-model="name" placeholder="请输入账单名称" style="width: 90%"/>
      </el-form-item>
      <el-form-item>
        <div class="dialog-footer">
          <el-button @click.native="cancel" >取消</el-button>
          <el-button type="primary" @click="submit" v-loading="loading">确定</el-button>
        </div>
      </el-form-item>
    </el-form>

  </div>
</template>

<script>
import {postFormData} from "@/api/api";
import {goldGiveAwayOrDeduct} from "@/api/url";
import GetPlain from "@/components/resume/GetPlainDialog";

export default {
  name: "GoldDetailDialog",
  components: {GetPlain},
  props: {
    value: Object
  },
  data() {
    return {
      goldDetailForm: this.value.goldDetailForm,
      goldNum: '',
      name: '',
      loading: false,
    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },
    submit() {
      if (!this.goldNum) {
        this.$message({
          message: '金币数量不能为空',
          duration: 2000,
          type: 'warning'
        })
        return false
      }
      if (!this.name) {
        this.$message({
          message: '账单名称不能为空',
          duration: 2000,
          type: 'warning'
        })
        return false
      }
      this.loading = true
      let param = {}
      param['userId'] = this.goldDetailForm.userId
      param['goldNum'] = this.goldNum
      param['billName'] = this.name
      postFormData(goldGiveAwayOrDeduct, param).then((data) => {
        let {code, msg} = data
        if ( code == 200 ) {
          this.$message({
            message: msg,
            duration: 2000,
            type: 'success'
          })
          this.$emit('confirm')
        } else {
          this.$message({
            message: msg,
            duration: 2000,
            type: 'success'
          })
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
.item-info {
  margin-top: 4px;
}
.item-info p {
  line-height: 24px;
}
</style>
